// Bumped on every deploy so we can spot which build a device is running.
// Displayed in the mobile bottom nav footer.
export const APP_VERSION = "1.10.0";
